(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("drag-scale-layer", [], factory);
	else if(typeof exports === 'object')
		exports["drag-scale-layer"] = factory();
	else
		root["drag-scale-layer"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'dragScaleLayer',
    props: {
        layerWidth: {
            type: Number,
            default: 800
        }, //定义弹窗宽度
        layerHeight: {
            type: Number,
            default: 500
        }, //定义弹窗高度
        layerLeft: {
            type: Number,
            default: 0
        }, //定义弹窗距左边界距离
        layerTop: {
            type: Number,
            default: 0
        }, //定义弹窗距顶部距离
        visible: {
            type: Boolean,
            default: false
        }, //定义弹窗显示状态属性 默认false
        title: {
            type: String,
            default: ""
        }, //定义弹窗显标题
        miniW: {
            type: Number,
            default: 200
        }, //缩放最小宽度 默认200px
        miniH: {
            type: Number,
            default: 200 //缩放最小高度 默认200px
        } },
    data: function data() {
        return {
            acType: -1, //定义操作弹窗动作类型 1为缩放 2为拖动

            visWidth: 1000, //保存页面文档宽度
            visHeight: 1000, //保存页面文档高度

            width: 800, //弹窗实际操作高度
            height: 500, //弹窗实际操作宽度
            left: 0, //弹窗距文档左边实际操作距离
            top: 0, //弹窗距顶部实际操作距离

            scale: {
                stX: 0,
                stY: 0,
                currW: 0,
                currH: 0
            }, //定义缩放临时参数

            move: {
                stX: 0,
                stY: 0,
                currL: 0,
                currT: 0
            }, //定义拖动临时参数

            fullScreen: false, //定义全屏弹窗状态
            fsWidth: 0,
            fsHeight: 0, //全屏显示时保存弹窗非全屏显示时的大小与状态
            fsLeft: 0,
            fsTop: 0
        };
    },
    mounted: function mounted() {
        var self = this;
        self.getDocSize(); //初始获取文档宽高

        window.addEventListener("resize", function () {
            self.getDocSize(); //监听window 宽高发生变化时 重新获取宽高
            if (self.fullScreen) {
                //全屏状态下更新弹窗宽高
                self.width = self.visWidth;
                self.height = self.visHeight;
            }
        }, false);
    },

    watch: {
        visible: function visible(val, oldVal) {
            //监听弹窗的显示状态 初始弹窗位置与大小
            if (val) {
                //如未定义弹窗位置则默认居中
                if (!this.layerLeft) {
                    this.left = (this.visWidth - this.layerWidth) / 2;
                };
                if (!this.layerTop) {
                    this.top = (this.visHeight - this.layerHeight) / 2;
                };
                this.width = this.layerWidth;
                this.height = this.layerHeight;
                this.fullScreen = false;
            }
        }
    },
    methods: {
        getDocSize: function getDocSize() {
            this.visWidth = document.documentElement.clientWidth || document.body.clientWidth;
            this.visHeight = document.documentElement.clientHeight || document.body.clientHeight;
        },
        scaleHandleMousedown: function scaleHandleMousedown(e) {
            //缩放弹窗 开始 
            if (this.fullScreen) return; //全屏时禁止缩放
            this.acType = 1;
            this.scale.stX = e.clientX;
            this.scale.stY = e.clientY;
            this.scale.currW = this.width;
            this.scale.currH = this.height;
        },
        moveHandleMousedown: function moveHandleMousedown(e) {
            //拖动弹窗 开始
            if (this.fullScreen) return;
            this.acType = 2;
            this.move.stX = e.clientX;
            this.move.stY = e.clientY;
            this.move.currL = this.left;
            this.move.currT = this.top;
        },
        handleMouseup: function handleMouseup(e) {
            //结束操作
            this.acType = -1;
        },
        handleMousemove: function handleMousemove(e) {
            if (this.acType === 1) {
                //缩放
                var crW = 0,
                    crH = 0;
                crW = this.scale.currW + (e.clientX - this.scale.stX);
                crH = this.scale.currH + (e.clientY - this.scale.stY);
                if (crW <= this.miniW) {
                    this.width = this.miniW;
                } else {
                    this.width = crW;
                };
                if (crH <= this.miniH) {
                    this.height = this.miniH;
                } else {
                    this.height = crH;
                }
            };
            if (this.acType === 2) {
                //移动
                this.left = this.move.currL + (e.clientX - this.move.stX);
                this.top = this.move.currT + (e.clientY - this.move.stY);
            }
        },
        handleClose: function handleClose() {
            //关闭弹窗
            this.$emit('close');
        },
        handleFullScreen: function handleFullScreen(type) {
            //全屏
            if (type == 1) {
                if (!this.fullScreen) return;
                this.fullScreen = false;

                this.width = this.fsWidth;
                this.height = this.fsHeight;
                this.left = this.fsLeft;
                this.top = this.fsTop;
            } else {
                if (this.fullScreen) return;
                this.fullScreen = true;

                this.fsWidth = this.width;
                this.fsHeight = this.height;
                this.fsLeft = this.left;
                this.fsTop = this.top;

                this.width = this.visWidth;
                this.height = this.visHeight;
                this.left = 0;
                this.top = 0;
            }
        }
    }
});

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__drag_scale_layer_vue__ = __webpack_require__(2);

// 导入组件 
var vueDragScaleLayer = {
    install: function install(Vue, options) {
        Vue.component(__WEBPACK_IMPORTED_MODULE_0__drag_scale_layer_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__drag_scale_layer_vue__["a" /* default */]);
    }
};

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(vueDragScaleLayer);
}

/* harmony default export */ __webpack_exports__["default"] = (vueDragScaleLayer);

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_2_vue_loader_lib_selector_type_script_index_0_drag_scale_layer_vue__ = __webpack_require__(0);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_2_vue_loader_lib_template_compiler_index_id_data_v_407a9c24_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_2_vue_loader_lib_selector_type_template_index_0_drag_scale_layer_vue__ = __webpack_require__(9);
function injectStyle (ssrContext) {
  __webpack_require__(3)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-407a9c24"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_2_vue_loader_lib_selector_type_script_index_0_drag_scale_layer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_2_vue_loader_lib_template_compiler_index_id_data_v_407a9c24_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_2_vue_loader_lib_selector_type_template_index_0_drag_scale_layer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("358ef0be", content, true, {});

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, ".layer-container[data-v-407a9c24]{position:fixed;top:0;left:0;width:100vw;height:100vh;z-index:2000}.layer-mask[data-v-407a9c24]{width:100vw;height:100vh;background:rgba(0,0,0,.4)}.layer-win[data-v-407a9c24]{position:fixed;top:25vh;left:25vw;width:50vw;height:50vh;background:#fff;border-radius:3px;overflow:hidden;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;-khtml-user-select:none;user-select:none}.layer-win .layer-header[data-v-407a9c24]{position:relative;height:40px;font-size:16px;line-height:40px;padding:0 10px;cursor:move;color:#909399}.layer-win .layer-header p[data-v-407a9c24]{margin:0;display:inline-block;max-width:calc(100% - 100px);overflow:hidden;text-overflow:ellipsis;white-space:nowrap;text-align:left}.layer-win .layer-header .layer-fn-btns[data-v-407a9c24]{float:right;height:100%}.layer-win .layer-header .layer-fn-btns i[data-v-407a9c24]{cursor:pointer;margin:0 5px}.layer-win .layer-header .layer-fn-btns i img[data-v-407a9c24]{width:25px;height:25px;vertical-align:middle}.layer-win .layer-header[data-v-407a9c24]:after{content:\"\";position:absolute;width:100%;height:1px;background:#eee;left:0;bottom:0}.layer-win .layer-content[data-v-407a9c24]{position:relative;width:100%;height:calc(100% - 40px)}.layer-win .layer-content .layer-content-mask[data-v-407a9c24]{position:absolute;top:0;left:0;z-index:100;width:100%;height:100%}.layer-win .scale-btn[data-v-407a9c24]{position:absolute;bottom:0;right:0;z-index:101;width:18px;height:18px;cursor:se-resize}.layer-win .scale-btn[data-v-407a9c24]:after{content:\"\";position:absolute;bottom:2px;right:2px;border-top:6px solid #656565;border-left:6px solid transparent;border-right:6px solid transparent;transform:translate(36%,36%) rotate(-45deg)}.fade-enter-active[data-v-407a9c24],.fade-leave-active[data-v-407a9c24]{transition:opacity .2s}.fade-enter[data-v-407a9c24],.fade-leave-to[data-v-407a9c24]{opacity:0}", ""]);

// exports


/***/ }),
/* 5 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(7)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 7 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 8 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.visible)?_c('div',{staticClass:"layer-container",on:{"mousemove":function($event){_vm.handleMousemove($event)},"mouseup":function($event){_vm.handleMouseup($event)}}},[_c('div',{staticClass:"layer-mask",on:{"click":_vm.handleClose}}),_vm._v(" "),_c('div',{staticClass:"layer-win",style:({width: _vm.width + 'px', height: _vm.height + 'px', left: _vm.left + 'px', top: _vm.top + 'px'})},[_c('div',{staticClass:"layer-header",on:{"mousedown":function($event){_vm.moveHandleMousedown($event)}}},[_c('p',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"layer-fn-btns"},[(_vm.fullScreen)?_c('i',{on:{"click":function($event){_vm.handleFullScreen(1)}}},[_c('img',{attrs:{"src":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NzNBMDlCRDBBNTFFMTFFOEFBQkNEMENCNTdCODIxRUUiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NzNBMDlCRDFBNTFFMTFFOEFBQkNEMENCNTdCODIxRUUiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo3M0EwOUJDRUE1MUUxMUU4QUFCQ0QwQ0I1N0I4MjFFRSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo3M0EwOUJDRkE1MUUxMUU4QUFCQ0QwQ0I1N0I4MjFFRSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PkpC/0oAAAD/SURBVHjaYvz//z8DrQHjqCWjltDPEkZGRhiTE4jPAbE0EP8l0rx/QPwGiOuB5q4gxhIQsAViXhIsUQXiaiB+BjTXGCbIgkWhORAXQX1wH4h/g+wmwoLzQDwJiPmBOBBZApslM4FYH4g3QDUQArCgmAjEp4D4ExD/JGQJDxDPAOJMEuP3JRCLAzEbugQTFsXfgFiAjETEjO4DfJZQHQxJS0D5hAMar3gtYURKMeTEywcgfo2a/oCZERkDwV0gXkiGBe+AuArqcA5kM7El4etAHAfEllCXMRCZVwSB+BE0yH4QKrtAhscCsSwpZSAQXwbiPlhQIZs7Wp+MUEsAAgwA0t1wYsj+U0MAAAAASUVORK5CYII=","alt":""}})]):_vm._e(),_vm._v(" "),(!_vm.fullScreen)?_c('i',{on:{"click":function($event){_vm.handleFullScreen(2)}}},[_c('img',{attrs:{"src":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NTg4M0JFMkFBNTFFMTFFOEIxMThBNDZGMjBENTBBNzQiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NTg4M0JFMkJBNTFFMTFFOEIxMThBNDZGMjBENTBBNzQiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo1ODgzQkUyOEE1MUUxMUU4QjExOEE0NkYyMEQ1MEE3NCIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo1ODgzQkUyOUE1MUUxMUU4QjExOEE0NkYyMEQ1MEE3NCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PlWh9u4AAACuSURBVHjaYvz//z8DrQHjqCWjltDXEkZGxnggFQ7E/EBMrCv+AvEpIF4DNPMkigzIEnQMBF+ghpOD52CYh8MSEOFFaqgA8Qcg3oFuHhMODb+AmINES3ihjvuDLsGERxMziZawwGKAFEuoBoa/JWxA/JhEs94B8T9sCYYFj6bNQHwDiFmJsABkOBcQCwHxZ2JzfCSQ8obm+H9E5hFQjj8LzSdnRkvhUUuGkSUAAQYAhViSuZhVoFcAAAAASUVORK5CYII=","alt":""}})]):_vm._e(),_vm._v(" "),_c('i',{on:{"click":_vm.handleClose}},[_c('img',{attrs:{"src":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NjMwQzY2RTFBNTFFMTFFODg0Njg5QUMwRDM1MTA0N0MiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NjMwQzY2RTJBNTFFMTFFODg0Njg5QUMwRDM1MTA0N0MiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo2MzBDNjZERkE1MUUxMUU4ODQ2ODlBQzBEMzUxMDQ3QyIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo2MzBDNjZFMEE1MUUxMUU4ODQ2ODlBQzBEMzUxMDQ3QyIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PoKfz3AAAADPSURBVHjaYvz//z8DrQETAx3AqCWjlmACRkbG60C8FIgZ8OAqIP6G1xZQPsGFgWA/SAkQT8ChPQUq/xCvOQQsAYEFUIM60SyIgYqfIehYIiwBgcVoPgqH8s8RFSJEWgICq6EG74XSN4gOdhIsAYENUAtekBS3JFiSALXgL5TuoLYlaUhxIArE06D8qdSyBJaKLoCyDpLFC5F9RIklGVCDruDIJyug8lMosQSc0QiUGjsgHsFtDgsBA7qB+CIBNY3QoMRdPI1Wv6OW0AwABBgA4JPXAFPKQMQAAAAASUVORK5CYII=","alt":""}})])])]),_vm._v(" "),_c('div',{staticClass:"layer-content"},[(_vm.acType > 0)?_c('div',{staticClass:"layer-content-mask"}):_vm._e(),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"scale-btn",on:{"mousedown":function($event){_vm.scaleHandleMousedown($event)}}})])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// drag-scale-layer.js